var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTouch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.2,23.7c-0.7-0.7-0.7-1.7,0-2.4c3-3,3-8,0-11c-3-3-8-3-11,0c-0.7,0.7-1.7,0.7-2.4,0c-0.7-0.7-0.7-1.7,0-2.4 c4.3-4.3,11.4-4.3,15.7,0c4.3,4.3,4.3,11.4,0,15.7C44.9,24.4,43.8,24.4,43.2,23.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.9,34.7c-0.7-0.7-0.7-1.7,0-2.4l2.8-2.7c0.7-0.7,0.6-1.7,0-2.4s-1.7-0.7-2.4,0c-0.7,0.7-1.7,0.7-2.4,0 c-0.7-0.7-0.7-1.7,0-2.4c1.9-2,5.1-2,7.1,0c1.9,1.9,2,5.1,0,7.1l-2.8,2.7C34.7,35.4,33.6,35.4,32.9,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.1,41c-0.7-0.7-0.7-1.7,0-2.4l2.8-2.8c0.7-0.7,0.6-1.7,0-2.4c-0.6-0.6-1.7-0.6-2.4,0 c-0.7,0.7-1.7,0.7-2.4,0c-0.7-0.7-0.7-1.7,0-2.4c1.9-1.9,5.1-1.9,7.1,0c1.9,1.9,1.9,5.1,0,7.1L38.4,41C37.8,41.7,36.7,41.7,36.1,41 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,50.4l-2.8-2.8c-3.6-3.6-5.1-8.6-4.1-13.5l2.8-13.8c0.5-2.4,2.6-4.1,5-4.1c2.8,0,5.2,2.4,5.2,5.2v1.9 l10.9-10.9c2-2,5.1-2,7.1,0c2,1.9,2,5.1,0,7.1L30.6,30c-0.7,0.7-1.7,0.7-2.4,0c-0.6-0.6-0.6-1.7,0-2.4L38.8,17 c0.7-0.7,0.7-1.7,0-2.4c-0.7-0.6-1.7-0.6-2.4,0L22.7,28.4c-0.5,0.5-1.2,0.6-1.8,0.4c-0.6-0.3-1-0.9-1-1.5v-5.9c0-1-0.9-1.8-1.8-1.8 c-0.8,0-1.5,0.6-1.7,1.4l-2.8,13.8c-0.8,3.8,0.4,7.8,3.2,10.5l2.8,2.8c4.5,4.5,12,4.5,16.5,0l5.9-5.9c0.6-0.6,0.6-1.7,0-2.4 c-0.6-0.6-1.7-0.6-2.4,0c-0.7,0.7-1.7,0.7-2.4,0c-0.7-0.7-0.7-1.7,0-2.4c1.9-1.9,5.1-1.9,7.1,0c1.9,1.9,1.9,5.1,0,7.1l-5.9,5.9 C32.6,56.3,23.1,56.3,17.2,50.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouch);
export default __webpack_public_path__ + "static/media/touch.15c345a921c9966a1d55067d03c803ac.svg";
export { ForwardRef as ReactComponent };